type IconProps = React.ComponentProps<'svg'>

export function Settings04Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(2.25, 4.25)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.75 8c1.81421 0 3.32734 1.28834 3.6748 3l11.3252 0c0.41421 0 0.75 0.33579 0.75 0.75 0 0.41421-0.33579 0.75-0.75 0.75l-11.3252 0c-0.34747 1.71166-1.8606 3-3.6748 3-2.07107 0-3.75-1.67893-3.75-3.75 0-2.07107 1.67893-3.75 3.75-3.75z m0 1.5c-1.24264 0-2.25 1.00736-2.25 2.25 0 1.24264 1.00736 2.25 2.25 2.25 1.24264 0 2.25-1.00736 2.25-2.25 0-1.24264-1.00736-2.25-2.25-2.25z m12-9.5c2.07107 0 3.75 1.67893 3.75 3.75 0 2.07107-1.67893 3.75-3.75 3.75-1.81421 0-3.32734-1.28834-3.6748-3l-11.3252 0c-0.41421 0-0.75-0.33579-0.75-0.75 0-0.41421 0.33579-0.75 0.75-0.75l11.3252 0c0.34747-1.71166 1.8606-3 3.6748-3z m0 1.5c-1.24264 0-2.25 1.00736-2.25 2.25 0 1.24264 1.00736 2.25 2.25 2.25 1.24264 0 2.25-1.00736 2.25-2.25 0-1.24264-1.00736-2.25-2.25-2.25z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}
